import { z } from "zod";

export const pushNotificationSchema = z
  .object({
    title: z.string().min(1, "Title is required"),
    message: z.string().min(1, "Message is required"),
    schedule_type: z.enum(["immediate", "scheduled"], {
      required_error: "Schedule type is required",
    }),
    scheduled_at: z.string().optional().nullable(),
    status: z.union([z.number(), z.string()]).optional(),
  })
  .refine(
    (data) =>
      data.schedule_type !== "scheduled" || Boolean(data.scheduled_at?.trim()),
    {
      message: "Scheduled at is required",
      path: ["scheduled_at"],
    }
  );

export type ZPushNotification = z.infer<typeof pushNotificationSchema>;
